let scrollPosition = 0;

function openSizeChart(type) {
    var popup = document.getElementById("sizeChartPopup" + type);
    var overlay = document.getElementById("sizeChartOverlay" + type);

    // Speichert die aktuelle Scrollposition
    scrollPosition = window.scrollY;

    if (!popup.parentElement.isSameNode(document.body)) {
        document.body.appendChild(popup);
        document.body.appendChild(overlay);
    }

    popup.style.display = "flex";
    overlay.style.display = "block";

    setTimeout(() => {
        popup.classList.add("active");
        overlay.classList.add("active");
    }, 10);

    // Fixiert den Body, ohne dass er sich nach oben bewegt
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.height = "100dvh";
    document.body.style.overflow = "hidden";
    document.body.style.top = `-${scrollPosition}px`;
}

function closeSizeChart(type) {
    var popup = document.getElementById("sizeChartPopup" + type);
    var overlay = document.getElementById("sizeChartOverlay" + type);

    popup.classList.remove("active");
    overlay.classList.remove("active");

    setTimeout(() => {
        popup.style.display = "none";
        overlay.style.display = "none";

        // Scroll-Position wiederherstellen
        document.body.style.position = "";
        document.body.style.width = "";
        document.body.style.height = "";
        document.body.style.overflow = "";
        document.body.style.top = "";
        window.scrollTo({ top: scrollPosition, behavior: "instant" });
    }, 300);
}
